import { render, staticRenderFns } from "./infoHonour.vue?vue&type=template&id=917e6512&scoped=true"
import script from "./infoHonour.vue?vue&type=script&lang=js"
export * from "./infoHonour.vue?vue&type=script&lang=js"
import style0 from "./infoHonour.vue?vue&type=style&index=0&id=917e6512&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917e6512",
  null
  
)

export default component.exports